/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { t, calc6Dict, calc6Ext, calcCommon } from '../../utils/calculatorTranslations'
import { PageContext } from '../../context/PageContextProvider'
import { useState, useContext, useEffect, useMemo } from 'react'
import { Calculator, Info, Attention } from '../../icons'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import StepLine from '../../components/core/stepLine'
import {
  DOMESTIC_NORMS,
  FOREIGN_NORMS,
  LEADER_CATEGORIES,
  calculateBusinessTrip2026,
} from './businessTripCalculator2026'

const Calculator6 = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [info, setInfo] = useState([])

  // Basic trip parameters
  const [tripType, setTripType] = useState('DOMESTIC')
  const [destinationKey, setDestinationKey] = useState('baku')
  const [startDate, setStartDate] = useState('2026-10-01')
  const [endDate, setEndDate] = useState('2026-10-04')
  const [isOneDayTrip, setIsOneDayTrip] = useState(false)
  const [isOvernightTransportTrip, setIsOvernightTransportTrip] = useState(false)
  const [isWeekendOrHolidayTravel, setIsWeekendOrHolidayTravel] = useState(false)

  // Leadership & Host
  const [leaderCategory, setLeaderCategory] = useState('CAT_0')
  const [hostProvisionStatus, setHostProvisionStatus] = useState('NONE')

  // Hotel
  const [hotelDocumentStatus, setHotelDocumentStatus] = useState('DOCUMENTED')
  const [actualHotelExpensePerNight, setActualHotelExpensePerNight] = useState('')

  // Transport & Other Expenses
  const [transportExpenses, setTransportExpenses] = useState(50)
  const [otherDocumentedExpenses, setOtherDocumentedExpenses] = useState(0)

  // Foreign currency
  const [exchangeRateToAZN, setExchangeRateToAZN] = useState(1.0)

  // Advances & Actual Paid
  const [paidAdvance, setPaidAdvance] = useState(500)
  const [actualPaidAllowance, setActualPaidAllowance] = useState('')

  // Modul B: Salary Preservation (AM 179 & Patch 4)
  const [tripWorkingDays, setTripWorkingDays] = useState(3)
  const [averageSalaryMode, setAverageSalaryMode] = useState('LEGAL_AVERAGE_CALCULATION')
  const [monthlySalary, setMonthlySalary] = useState(1200)
  const [normalWorkingDaysInMonth, setNormalWorkingDaysInMonth] = useState(21)
  const [userProvidedDailyRate, setUserProvidedDailyRate] = useState(57.14)

  useEffect(() => {
    (async () => {
      try {
        const data1 = await PagesAPI.getMagazinePageInfo()
        setInfo(data1?.data || [])
      } catch (e) {}
      setLoad(true)
    })()
  }, [])

  // Auto-set exchange rate and destination when tripType changes
  useEffect(() => {
    if (tripType === 'DOMESTIC') {
      setDestinationKey('baku')
      setExchangeRateToAZN(1.0)
    } else {
      setDestinationKey('turkey_istanbul')
      setExchangeRateToAZN(1.85) // EUR default
    }
  }, [tripType])

  // Update default exchange rate when foreign destination changes
  const handleDestinationChange = (key) => {
    setDestinationKey(key)
    if (tripType === 'FOREIGN') {
      const norm = FOREIGN_NORMS[key]
      if (norm) {
        if (norm.currency === 'EUR') setExchangeRateToAZN(1.85)
        else if (norm.currency === 'USD') setExchangeRateToAZN(1.70)
        else if (norm.currency === 'GBP') setExchangeRateToAZN(2.15)
        else if (norm.currency === 'CHF') setExchangeRateToAZN(1.95)
        else if (norm.currency === 'JPY') setExchangeRateToAZN(0.011)
        else setExchangeRateToAZN(1.0)
      }
    }
  }

  // Handle 1-day trip toggle
  const handleOneDayTripToggle = (checked) => {
    setIsOneDayTrip(checked)
    if (checked) {
      setEndDate(startDate)
      setTripWorkingDays(1)
    }
  }

  // Handle start date change
  const handleStartDateChange = (val) => {
    setStartDate(val)
    if (isOneDayTrip) {
      setEndDate(val)
    }
  }

  const steps = [
    {
      title: translate.calculation_type,
      text: translate.make_your_choice,
    },
    {
      title: translate.basic_information,
      text: translate.enter_info,
    },
    {
      title: translate.result,
      text: translate.ready,
    },
  ]

  const handleSubmit = (e) => {
    e.preventDefault()

    const inputData = {
      tripType,
      destinationKey,
      startDate,
      endDate: isOneDayTrip ? startDate : endDate,
      isOneDayTrip,
      isOvernightTransportTrip,
      isWeekendOrHolidayTravel,
      leaderCategory,
      hostProvisionStatus,
      hotelDocumentStatus,
      actualHotelExpensePerNight: actualHotelExpensePerNight !== '' ? Number(actualHotelExpensePerNight) : null,
      transportExpenses: Number(transportExpenses) || 0,
      otherDocumentedExpenses: Number(otherDocumentedExpenses) || 0,
      exchangeRateToAZN: tripType === 'FOREIGN' ? (Number(exchangeRateToAZN) || 1.0) : 1.0,
      paidAdvance: Number(paidAdvance) || 0,
      actualPaidAllowance: actualPaidAllowance !== '' ? Number(actualPaidAllowance) : null,
      tripWorkingDays: Number(tripWorkingDays) || 0,
      averageSalaryMode,
      monthlySalary: Number(monthlySalary) || 0,
      normalWorkingDaysInMonth: Number(normalWorkingDaysInMonth) || 21,
      userProvidedDailyRate: Number(userProvidedDailyRate) || 0,
    }

    const calcResult = calculateBusinessTrip2026(inputData)
    sessionStorage.setItem('businesstrip_result_2026', JSON.stringify(calcResult))
    window.location.href = '/useful/calculator/result6'
  }

  const currentNorm = tripType === 'DOMESTIC' ? DOMESTIC_NORMS[destinationKey] : FOREIGN_NORMS[destinationKey]

  return load ? (
    <section className={`${styles.container} ${className || ''}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={1} data={steps} />
      </div>

      <h1 className={styles.pageTitle}>
        <Calculator width={32} height={32} />
        <span>{t(calc6Dict.title, language)}</span>
      </h1>

      <form className={styles.formCard} onSubmit={handleSubmit}>
        {/* Section 1: Ezamiyyə İstiqaməti və Ərazisi */}
        <div className={styles.sectionHeader}>
          <div className={styles.sectionNum}>1</div>
          <h3>{language === 'TR' ? 'İş Seyahati Yönü ve Bölgesi (Bakanlar Kurulu No. 14)' : language === 'ENG' ? 'Business Trip Destination & Region (Decree No. 14)' : language === 'RU' ? 'Направление командировки (Постановление №14)' : 'Ezamiyyə İstiqaməti və Məntəqəsi (NK №14 və 200 nömrəli Qərar)'}</h3>
        </div>

        <div className={styles.grid3}>
          <div className={styles.inputGroup}>
            <label>{t(calc6Dict.tripType, language)}</label>
            <select value={tripType} onChange={(e) => setTripType(e.target.value)}>
              <option value="DOMESTIC">{t(calc6Dict.domestic, language)}</option>
              <option value="FOREIGN">{t(calc6Dict.foreign, language)}</option>
            </select>
          </div>

          <div className={styles.inputGroup}>
            <label>{t(calc6Dict.destinationCity, language)}</label>
            <select
              value={destinationKey}
              onChange={(e) => handleDestinationChange(e.target.value)}
            >
              {tripType === 'DOMESTIC'
                ? Object.keys(DOMESTIC_NORMS).map((k) => (
                    <option key={k} value={k}>
                      {DOMESTIC_NORMS[k].name} ({DOMESTIC_NORMS[k].dailyNorm} AZN/gün)
                    </option>
                  ))
                : Object.keys(FOREIGN_NORMS)
                    .filter((k) => FOREIGN_NORMS[k].id === k)
                    .map((k) => (
                    <option key={k} value={k}>
                      {FOREIGN_NORMS[k].country} — {FOREIGN_NORMS[k].city} ({FOREIGN_NORMS[k].dailyNorm} {FOREIGN_NORMS[k].currency}/gün)
                    </option>
                  ))}
            </select>
          </div>

          {tripType === 'FOREIGN' && (
            <div className={styles.inputGroup}>
              <label>Məzənnə (1 {currentNorm?.currency} = ? AZN)</label>
              <input
                type="number"
                step="0.0001"
                min="0.0001"
                value={exchangeRateToAZN}
                onChange={(e) => setExchangeRateToAZN(e.target.value)}
                required
              />
              <span className={styles.hint}>{t(calc6Ext.cbarRateHint, language)}</span>
            </div>
          )}
        </div>

        {/* Section 2: Ezamiyyə Tarixləri və Rejimlər */}
        <div className={styles.sectionHeader}>
          <div className={styles.sectionNum}>2</div>
          <h3>Ezamiyyə Müddəti və Xüsusi Rejimlər (Patch 1, 2, 3)</h3>
        </div>

        <div className={styles.grid3}>
          <div className={styles.inputGroup}>
            <label>{t(calc6Ext.startDate, language)}</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => handleStartDateChange(e.target.value)}
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label>{t(calc6Ext.endDate, language)}</label>
            <input
              type="date"
              value={endDate}
              disabled={isOneDayTrip}
              onChange={(e) => setEndDate(e.target.value)}
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Rəhbər heyət kateqoriyası (Əlavə 2)</label>
            <select
              value={leaderCategory}
              onChange={(e) => setLeaderCategory(e.target.value)}
            >
              {Object.keys(LEADER_CATEGORIES).map((c) => (
                <option key={c} value={c}>
                  {LEADER_CATEGORIES[c].label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={styles.grid3}>
          <div className={styles.checkboxGroup}>
            <input
              type="checkbox"
              id="oneDayTrip"
              checked={isOneDayTrip}
              onChange={(e) => handleOneDayTripToggle(e.target.checked)}
            />
            <label htmlFor="oneDayTrip">1 günlük ezamiyyə (mehmanxana verilmir, gündəlik 30%/40%)</label>
          </div>

          <div className={styles.checkboxGroup}>
            <input
              type="checkbox"
              id="overnightTransport"
              checked={isOvernightTransportTrip}
              disabled={isOneDayTrip}
              onChange={(e) => setIsOvernightTransportTrip(e.target.checked)}
            />
            <label htmlFor="overnightTransport">Gecə nəqliyyatında gecələmə / qatar (Patch 1: hotel = 0, gündəlik qalır)</label>
          </div>

          <div className={styles.checkboxGroup}>
            <input
              type="checkbox"
              id="weekendTravel"
              checked={isWeekendOrHolidayTravel}
              onChange={(e) => setIsWeekendOrHolidayTravel(e.target.checked)}
            />
            <label htmlFor="weekendTravel">İstirahət/bayram günündə səfər (Patch 3: ƏM 164 kompensasiya)</label>
          </div>
        </div>

        {/* Section 3: Qonaqlama və Mehmanxana */}
        <div className={styles.sectionHeader}>
          <div className={styles.sectionNum}>3</div>
          <h3>Mehmanxana və Qonaqlama Xərcləri (NK №14 və DVX İzahatı)</h3>
        </div>

        <div className={styles.grid3}>
          <div className={styles.inputGroup}>
            <label>Mehmanxana sənədinin statusu</label>
            <select
              value={hotelDocumentStatus}
              disabled={isOneDayTrip || isOvernightTransportTrip}
              onChange={(e) => setHotelDocumentStatus(e.target.value)}
            >
              <option value="DOCUMENTED">Sənədli (Faktiki təsdiqedici invoys / qəbz var)</option>
              <option value="NOT_DOCUMENTED">Sənədsiz (Təsdiqedici sənəd təqdim edilməyib)</option>
            </select>
          </div>

          {hotelDocumentStatus === 'DOCUMENTED' && !isOneDayTrip && !isOvernightTransportTrip ? (
            <div className={styles.inputGroup}>
              <label>Faktiki 1 gecəlik hotel xərci ({currentNorm?.currency})</label>
              <input
                type="number"
                step="0.01"
                min="0"
                placeholder={currentNorm ? (currentNorm.dailyNorm * currentNorm.hotelPercent).toFixed(2) : '0'}
                value={actualHotelExpensePerNight}
                onChange={(e) => setActualHotelExpensePerNight(e.target.value)}
              />
              <span className={styles.hint}>Boş qaldıqda rəsmi norma qədər qəbul edilir</span>
            </div>
          ) : (
            <div className={styles.inputGroup}>
              <label>Qonaqlama hüquqi rejimi</label>
              <div style={{ paddingTop: '8px' }}>
                <span style={{ fontSize: '13px', fontWeight: '600', color: '#166fe5' }}>
                  Normativ {tripType === 'DOMESTIC' ? '70%' : '60%'} hotel hissəsi tətbiq olunur ({currentNorm ? (currentNorm.dailyNorm * currentNorm.hotelPercent).toFixed(2) : '0'} {currentNorm?.currency}/gecə)
                </span>
              </div>
            </div>
          )}

          <div className={styles.inputGroup}>
            <label>{t(calc6Dict.hostProvision, language)}</label>
            <select
              value={hostProvisionStatus}
              onChange={(e) => setHostProvisionStatus(e.target.value)}
            >
              <option value="NONE">Heç biri (Xərclər tam ezam edən tərəfindən ödənilir)</option>
              <option value="ACCOMMODATION">Yaşayış yeri təmin edilir (hotel xərci verilmir)</option>
              <option value="MEALS">Yemək xərcləri təmin edilir (gündəlik xərc verilmir)</option>
              <option value="ACCOMMODATION_AND_MEALS">Həm yaşayış, həm yemək təmin edilir</option>
              <option value="ALL_EXPENSES">Bütün xərclər qəbul edən tərəfindən ödənilir</option>
            </select>
          </div>
        </div>

        {hotelDocumentStatus === 'NOT_DOCUMENTED' && !isOneDayTrip && !isOvernightTransportTrip && (
          <div className={styles.alertNotice}>
            <Info width={20} height={20} />
            <div>
              <strong>Q-01 və NK №14 Qaydası:</strong> NK №14-ün 1-1-ci bəndi (keçmiş 50% sənədsiz qaydası) ləğv edilmişdir. Sənəd təqdim edilmədikdə 50% deyil, normativ {tripType === 'DOMESTIC' ? '70%' : '60%'}-lik mehmanxana hissəsi qanuni hüquq olaraq tətbiq olunur.
            </div>
          </div>
        )}

        {/* Section 4: Nəqliyyat, Əlavə Xərclər və Avans */}
        <div className={styles.sectionHeader}>
          <div className={styles.sectionNum}>4</div>
          <h3>Nəqliyyat, Digər Xərclər və Avans Hesabatı (Patch 2)</h3>
        </div>

        <div className={styles.grid4}>
          <div className={styles.inputGroup}>
            <label>Nəqliyyat xərcləri ({currentNorm?.currency})</label>
            <input
              type="number"
              step="0.01"
              min="0"
              value={transportExpenses}
              onChange={(e) => setTransportExpenses(e.target.value)}
            />
            <span className={styles.hint}>Bilet, taksi, transfer</span>
          </div>

          <div className={styles.inputGroup}>
            <label>Digər sənədli xərclər ({currentNorm?.currency})</label>
            <input
              type="number"
              step="0.01"
              min="0"
              value={otherDocumentedExpenses}
              onChange={(e) => setOtherDocumentedExpenses(e.target.value)}
            />
            <span className={styles.hint}>Viza, sığorta, rüsumlar</span>
          </div>

          <div className={styles.inputGroup}>
            <label>Ödənilmiş avans (AZN)</label>
            <input
              type="number"
              step="0.01"
              min="0"
              value={paidAdvance}
              onChange={(e) => setPaidAdvance(e.target.value)}
            />
            <span className={styles.hint}>Səfərdən əvvəl verilən məbləğ</span>
          </div>

          <div className={styles.inputGroup}>
            <label>Faktiki ödənilmiş məbləğ (AZN)</label>
            <input
              type="number"
              step="0.01"
              min="0"
              placeholder="Avtomatik (faktiki xərc)"
              value={actualPaidAllowance}
              onChange={(e) => setActualPaidAllowance(e.target.value)}
            />
            <span className={styles.hint}>Vergi simulyasiyası üçün (VM 98.3 / 109.7)</span>
          </div>
        </div>

        {/* Section 5: Modul B — Əməkhaqqının Saxlanılması (ƏM m.179) */}
        <div className={styles.sectionHeader}>
          <div className={styles.sectionNum}>5</div>
          <h3>Modul B: ƏM m.179 Saxlanılan Orta Əməkhaqqı (Patch 4)</h3>
        </div>

        <div className={styles.grid3}>
          <div className={styles.inputGroup}>
            <label>Ezamiyyəyə düşən iş günləri</label>
            <input
              type="number"
              min="0"
              max="60"
              value={tripWorkingDays}
              onChange={(e) => setTripWorkingDays(e.target.value)}
              required
            />
            <span className={styles.hint}>Ezamiyyət müddətindəki faktiki iş günləri</span>
          </div>

          <div className={styles.inputGroup}>
            <label>Orta əməkhaqqı hesablama rejimi</label>
            <select
              value={averageSalaryMode}
              onChange={(e) => setAverageSalaryMode(e.target.value)}
            >
              <option value="LEGAL_AVERAGE_CALCULATION">Ştat üzrə vəzifə maaşı ilə simulyasiya</option>
              <option value="USER_PROVIDED_AVERAGE">ƏM 177 üzrə faktiki orta gündəlik qazanc</option>
            </select>
          </div>

          {averageSalaryMode === 'LEGAL_AVERAGE_CALCULATION' ? (
            <>
              <div className={styles.inputGroup}>
                <label>Aylıq vəzifə maaşı (AZN)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={monthlySalary}
                  onChange={(e) => setMonthlySalary(e.target.value)}
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Aylıq iş günlərinin sayı</label>
                <input
                  type="number"
                  min="1"
                  max="31"
                  value={normalWorkingDaysInMonth}
                  onChange={(e) => setNormalWorkingDaysInMonth(e.target.value)}
                />
                <span className={styles.hint}>İstehsalat təqviminə əsasən (default 21 gün)</span>
              </div>
            </>
          ) : (
            <div className={styles.inputGroup}>
              <label>Faktiki orta gündəlik əməkhaqqı (AZN)</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={userProvidedDailyRate}
                onChange={(e) => setUserProvidedDailyRate(e.target.value)}
              />
              <span className={styles.hint}>Əvvəlki 2 ayın tam bordrosu əsasında çıxan rəqəm</span>
            </div>
          )}
        </div>

        <div className={styles.submitSection}>
          <button type="submit" className={styles.submitBtn}>
            <Calculator width={20} height={20} />
            <span>Hesabla və Nəticəni Göstər</span>
          </button>
        </div>
      </form>
    </section>
  ) : (
    <Loading />
  )
}

export default Calculator6
